/**
 * Build the SHAREABLE URL for a public listing.
 *
 * Usa `/api/share/{publicId}` invece di `/listing/{publicId}` perché:
 *  • Quando un crawler social (WhatsApp, Telegram, Facebook, iMessage…)
 *    visita questo URL, il backend serve HTML con i meta tag Open Graph
 *    (titolo, descrizione, foto hero) → preview ricco nel chat.
 *  • Quando un browser umano segue il link, il backend ritorna un 302
 *    redirect verso `/listing/{publicId}` → la SPA React si carica
 *    normalmente.
 *
 * Per VISUALIZZARE l'URL all'agente (copy/code box) usa invece `getDisplayUrl`
 * che ritorna l'URL "pulito" `/listing/{publicId}`.
 */
export function getShareUrl(publicId, origin) {
  if (!publicId) return "";
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  return `${base}/api/share/${publicId}`;
}

/** URL "pulito" per copia/display all'agente. Apertura SPA. */
export function getDisplayUrl(publicId, origin) {
  if (!publicId) return "";
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  return `${base}/listing/${publicId}`;
}
